import Sidemenu from "../../layout/sidemenu";
import Header from "../../layout/header";
import { Tooltip } from 'react-tooltip';
import { useNavigate } from "react-router";
import { useState,useEffect } from "react";
import { NoAuthApiRequest,ApiRequest } from "../services/apiservice";
import { ApiEndpoints,ApiEndpointMethod } from "../../utils/endpoints";
import { Formik } from 'formik';
import AssignUser from "../assign-user";
import { ToastContainer, toast } from "react-toastify";
import React, { useRef } from 'react';
import Swal from "sweetalert2";
import  Loader from '../shared/loader';
import { saveAs } from 'file-saver';

const ImportTimeSheet = () => {
      
         const usrDetails = JSON.parse(localStorage.getItem("user"));
        const [isCollapsed, setIsCollapsed] = useState(false);
        const [loader,setloader]=useState(false);
        
            const [IsAdmin,setIsAdmin]=useState(false);
             const navigate = useNavigate();
          
            const[lstImportedTimesheet,setlstImportedTimesheet] = useState([]);
         

         const [currentPage, setCurrentPage] = useState(1);
         const [pageSize, setPageSize] = useState(100); // Default page size
         const [totalPages, setTotalPages] = useState(0);
        
         const [startCount, setstartCount] = useState("");
         const [endCount, setendCount] = useState("");
        const [totalCount, settotalCount] = useState("");
       
   const statusLabel = {
        1: 'New',
        2: 'In Progress',
        3: 'Completed',
        4: 'Exception'
    };

        
           
const [FieldValue, setFieldValue] = useState();
        

const closeModal = () => {
  document.getElementById('btnClose').click();
}

     // Add this method inside your ImportTimeSheet component
const handleFileImport = async (values, actions) => {
  debugger;
  if (!values.file) {
    toast.error("Please select a file to import.");
    return;
  }
  const formDataToSend = new FormData();
  formDataToSend.append("files", values.file);
 const usrDetails = JSON.parse(localStorage.getItem("user"));
                                 
  // Append other fields if needed
  // formDataToSend.append("ProjectId", values.ProjectId);
debugger;
  try {
    setloader(true);
    var URL= `${process.env.REACT_APP_API_URL}${ApiEndpoints.TimeSheet.ImportFile(usrDetails.Id)}`;
    // process.env.REACT_APP_API_URL+ ApiEndpoints.TimeSheet.ImportFile(usrDetails.Id);
    const response = await fetch(URL, {
      method: "POST",
      body: formDataToSend,
      // Do not set Content-Type header for FormData
    });

    const result = await response.json();
    if (result =="") {
         document.getElementById('btnC').click();
      toast.success("File imported successfully!");
        await fetchTimeSheetList();
         actions.resetForm();
      // Optionally refresh data here
    } else {
      toast.error(result || "Import failed.");
    }
  } catch (error) {
    toast.error("An error occurred during import.");
  } finally {
    setloader(false);
    actions.setSubmitting(false);
  }
};
              
         
                           useEffect(() => {
                                 const fetchData = async () => {
                                                    
                                                 await fetchTimeSheetList();
                                                             
                                 };
                                   fetchData();
                                                   
                                  },[]);
                                        
                                          
                                            
    
                                             const  getWeekNumber= async(date) => {
                                                var d = new Date(date);
                                                d.setHours(0, 0, 0, 0);
                                                d.setDate(d.getDate() + 4 - (d.getDay() || 7)); // Set to nearest Thursday
                                                var startOfYear = new Date(d.getFullYear(), 0, 1);
                                                var weekNo = Math.ceil((( (d - startOfYear) / 86400000) + 1) / 7);
                                                return weekNo;
                                            }
    
                                            
                              
                              const fetchTimeSheetList = async()=>{
                                  await fetchTimeSheet(1,pageSize);
                              }
                          
                              const handlePageChange = (page) => {
                                  setCurrentPage(page);
                                  fetchTimeSheet(page, pageSize);
                              };
                          
                              const getPageNumbers = () => {
                                  // Dynamically generate page numbers
                                  const pageNumbers = [];
                                  let startPage = Math.max(1, currentPage - 1);  // Prevent going below 1
                                  let endPage = Math.min(totalPages, currentPage + 1);  // Prevent going above totalPages
                                
                                  for (let i = startPage; i <= endPage; i++) {
                                      pageNumbers.push(i);
                                  }
                                  return pageNumbers;
                                };
                                  
                                          const fetchTimeSheet= async (page, limit) => {
                                               
                                              try {
                                                  setloader(true);
                                                 // setLoader(true);
                                                 const usrDetails = JSON.parse(localStorage.getItem("user"));
                                 
                                                  const data = await ApiRequest(ApiEndpoints.TimeSheet.FetchImportedFiles(usrDetails.Id,page,limit), ApiEndpointMethod.Post, null, navigate);
                                                  
                                                  
                                                  await setlstImportedTimesheet(data.Item1);
                                                  const totalPages = Math.ceil(data.Item2 / limit);
                                                  setTotalPages(totalPages);
                                      
                                                  const startcount = Math.ceil(
                                                      Math.ceil(Math.ceil(page * limit) - limit) + 1
                                                  );
                                                  let endcount = Math.ceil(page * limit);
                                                  if (endcount > data.Item2) {
                                                      endcount = Math.ceil(endcount - Math.ceil(endcount - data.Item2));
                                                  }
                                                  setstartCount(startcount);
                                                  setendCount(endcount);
                                                 settotalCount(data.Item2);
                                                  return { data };
                                                  // Handle the response data here (e.g., show success message or update UI)
                                              } catch (error) {
                                                  console.error("Error during API call:", error);
                                                  // await setfileList([]);
                                                  // Handle errors (e.g., show an error message to the user)
                                              }
                                              finally {
                                               ///   setLoader(false);
                                               setloader(false);
                                              }
                                          };
                          
                            const formatDateUTCDate = (dateString) => {
                                const date = new Date(dateString);
                            
                                // Adjust to local time
                                const month = date.getMonth() + 1; // Months are zero-indexed
                                const day = date.getDate();
                                const year = date.getFullYear();
                            
                                return `${month}/${day}/${year}`;
                            }

                            const ClearField = (resetForm) => {
  if (resetForm) resetForm();
  // Optionally, clear the file input manually
  const fileInput = document.getElementById("formFile");
  if (fileInput) fileInput.value = "";
};

const DownloadSamplefile = async () => {
  try {
    const filebytes="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";
    downloadExcelFile(filebytes,"Sample Timesheet Import Template");
  }
  catch (error) {
  }
}

 const downloadExcelFile = (base64String,filename) => {
        // Decode the base64 string
        const byteCharacters = atob(base64String);
        const byteArrays = [];
    
        // Create a byte array
        for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
          const slice = byteCharacters.slice(offset, offset + 1024);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          byteArrays.push(new Uint8Array(byteNumbers));
        }
    
        // Create a Blob from the byte array
        const blob = new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
        // Trigger the file download
        saveAs(blob, filename+'.xlsx');
      };

    return (
        <>
            <div className={`workspace-wrapper ${isCollapsed ? "collapsed" : ""}`}>
                <Sidemenu />
                <div className="workspace">
                    <Header toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
                    <div className="workspace-content">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="d-flex align-items-center">
                                <h5 className="mb-0 me-2">Import Time sheet</h5>
                                {/* <div className="heading-badge"><small>Total Hours:</small>{dailyTotal} Hrs</div>
                                <div className="heading-badge" style={{marginLeft:"5px"}}><small>Billable Hours:</small>{billableTotal} Hrs</div>
                                <div className="heading-badge" style={{marginLeft:"5px"}}><small>Non billable Hours:</small>{nonbillableTotal} Hrs</div>
                                {displayEstimatedHours && (
                                <div  className="heading-badge" style={{marginLeft:"5px"}}><small>Estimated Hours:</small>{estimatedHours} Hrs</div>
                                )} */}
                            </div>
                            <div>
                                <div className="dropdown">
                                    <button className="btn btn-sm btn-outline-info" type="button"
                                    //  data-bs-toggle="dropdown"
                                     aria-expanded="false" id="mdladdFile" data-bs-toggle="modal"
                                    data-bs-target="#addFile">
                                        <i className="fas fa-file-export me-1"></i>
                                        Import
                                    </button>
                                    {/* <ul className="dropdown-menu">
                                        <li><a className="dropdown-item" href="#">Excel</a></li>
                                        <li><a className="dropdown-item" href="#">PDF</a></li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>

                        {/* <div className="">
                            <div className="row mb-2">
                                
                            </div>
                        </div> */}

                        <div className="table-wrapper weekly-table">
                            <table className="table table-striped table-bordered bg-white align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th width="10%">Date</th>
                                        <th width="25%">File Name</th>
                                        <th width="10%">Status</th>
                                        <th width="5%">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {lstImportedTimesheet?.map((time) => (
                                    <tr>
                                         <td>{formatDateUTCDate(time.InsertedDate)}</td>
                                        <td>{time.FileName}</td>
                                        <td>{statusLabel[time.Status]}</td>
                                        <td style={{textAlign:"center"}}>
                                        {time.Message && (
  <i className="fa-solid fa-info-circle"
     style={{ cursor: "pointer", color: "red" }}
     data-bs-toggle="tooltip"
     title={time.Message}>
  </i>
)}
{time.OutputContent && (
  <i
    className="fa-solid fa-download"
    style={{ cursor: "pointer", color: "green" }}
    onClick={() => {
        const cleanedFileName = time.FileName.replace(".xlsx", "");
         downloadExcelFile(time.OutputContent,cleanedFileName);}}
  ></i>
)}
                                          </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="pagination-wrapper shadow-sm">
                               <p className="mb-0 me-2">{startCount} - {endCount} of {totalCount}</p>
                               <ul className="pagination">
                                   <li className={`pagination-previous ${currentPage === 1 ? 'disabled' : ''}`}>
                                       <a onClick={(e) => { e.preventDefault(); if (currentPage > 1) handlePageChange(currentPage - 1); }}>
                                           <i className="fa-solid fa-chevron-left"></i>
                                       </a>
                                   </li>

                                   {getPageNumbers().map((page) => (
                                       <li key={page} >
                                           <a className={page === currentPage ? 'active' : ''} onClick={(e) => { e.preventDefault(); handlePageChange(page); }}>
                                               {page}
                                           </a>
                                       </li>
                                   ))}

                                   <li className={`pagination-next ${currentPage === totalPages ? 'disabled' : ''}`}>
                                       <a onClick={(e) => { e.preventDefault(); if (currentPage < totalPages) handlePageChange(currentPage + 1); }}>
                                           <i className="fa-solid fa-chevron-right"></i>
                                       </a>
                                   </li>
                               </ul>
                        </div>
                    </div>
                </div>
            </div>

 <div className="modal fade" id="addFile" style={{top:"15%"}} tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-md">
    <div className="modal-content">
      
      <Formik
        enableReinitialize={true}
        initialValues={{file: null }}
        onSubmit={(values, actions) => {
          // handle file upload here
          // Example: handleFileImport(values);
          handleFileImport(values,actions);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          resetForm
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
        <h5 className="modal-title">Import File</h5>
        <button
          type="button"
          className="btn-close"
           id="btnC"
          onClick={() => { ClearField(resetForm); }}
          data-bs-dismiss="modal"
        ></button>
      </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label>
                      Select File<span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="formFile"
                      name="file"
                      accept=".xlsx"
                      onChange={event => {
                         const file = event.currentTarget.files[0];
                          if (file && !file.name.endsWith('.xlsx')) {
                         toast.error("Please select a valid Excel file (.xlsx)");
                           event.target.value = ""; // Clear the file input in the DOM
                           setFieldValue("file", null);
                           } else {
                         setFieldValue("file", event.currentTarget.files[0]);
                       }  
                        
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-12" style={{textAlign:"right"}}>
                  <a style={{textDecoration:"underline"}} onClick={DownloadSamplefile}>Sample File</a>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="btnClose"
                className="btn btn-sm btn-outline-info me-2"
                data-bs-dismiss="modal"
                onClick={() => { ClearField(resetForm); }}
              >
                <i className="fas fa-times me-2"></i>Cancel
              </button>
              <button
                type="submit"
                className="btn btn-sm btn-info"
              >
                <i className="fas fa-check me-2"></i>Save
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  </div>
</div>

            <Tooltip id="editTooltip" />
            <Tooltip id="deleteTooltip" />
            {loader && (
                <Loader/>
            )}
        </>
    )
}

export default ImportTimeSheet;